// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__x2N9W","categoryName":"style_categoryName__7e8VX","offerList":"style_offerList__azLUW"};